import { useState, type FormEvent } from "react";

const FORM_URL = "https://readdy.ai/api/form/dadqajjep053ijub13t0";

export default function Subscribe() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [msg, setMsg] = useState("");

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    // honeypot check
    const honeypot = String(formData.get("company_alt") || "").trim();
    if (honeypot) {
      setStatus("success");
      setMsg("订阅成功，欢迎加入吃瓜时间线！");
      form.reset();
      return;
    }
    formData.delete("company_alt");

    setStatus("loading");
    setMsg("");
    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
      const ok = res.ok && parsed?.code === "OK";
      if (ok) {
        setStatus("success");
        setMsg("订阅成功，欢迎加入吃瓜时间线！每周为你准时推送重要进展。");
        form.reset();
      } else {
        setStatus("error");
        setMsg(serverMsg || "订阅失败，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setMsg("网络开小差了，请稍后再试。");
    }
  }

  return (
    <section id="subscribe" className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <div className="overflow-hidden rounded-3xl bg-primary-500 px-6 py-10 md:px-12 md:py-14">
        <div className="grid items-center gap-8 lg:grid-cols-2">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/20 px-3 py-1 text-xs font-bold text-background-50">
              <i className="ri-mail-send-line text-sm"></i>
              瓜讯订阅
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black leading-tight text-background-50 md:text-3xl">
              重要瓜，不错过
            </h2>
            <p className="mt-3 max-w-md text-sm leading-relaxed text-background-100">
              订阅我们的瓜讯邮件，当正在发酵的事件出现关键反转或新进展时，第一时间推送给你。
            </p>
          </div>

          <form onSubmit={handleSubmit} data-readdy-form className="w-full">
            <div className="flex flex-col gap-3 sm:flex-row">
              <input
                type="email"
                name="email"
                required
                placeholder="输入你的邮箱"
                autoComplete="email"
                className="h-12 flex-1 rounded-full border border-background-50/30 bg-background-50 px-5 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-accent-400"
              />
              <button
                type="submit"
                disabled={status === "loading"}
                className="inline-flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-full bg-background-950 px-7 text-sm font-bold text-background-50 transition-opacity hover:opacity-90 disabled:opacity-60"
              >
                {status === "loading" ? (
                  <>
                    <i className="ri-loader-4-line animate-spin text-base"></i> 提交中
                  </>
                ) : (
                  <>
                    立即订阅 <i className="ri-send-plane-line text-base"></i>
                  </>
                )}
              </button>
            </div>

            {/* honeypot */}
            <div className="opt-in-collector" aria-hidden="true">
              <input
                type="text"
                name="company_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
            </div>

            {status === "success" && (
              <p className="mt-3 flex items-center gap-1.5 text-sm font-medium text-accent-200">
                <i className="ri-checkbox-circle-line text-base"></i>
                {msg}
              </p>
            )}
            {status === "error" && (
              <p className="mt-3 flex items-center gap-1.5 text-sm font-medium text-background-50">
                <i className="ri-error-warning-line text-base"></i>
                {msg}
              </p>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}